export default "__VITE_ASSET__ClDty4cP__"